// Investment Glossary - Key venture capital terms

export const glossary = [
  {
    term: "Accredited Investor",
    definition: "An individual or entity that meets specific financial criteria set by regulatory authorities, allowing them to invest in private securities and venture capital opportunities."
  },
  {
    term: "Angel Investor",
    definition: "An individual who provides capital for startup companies, typically in exchange for convertible debt or ownership equity. Angels usually invest in early-stage companies."
  },
  {
    term: "Assets Under Management (AUM)",
    definition: "The total market value of all investments that a fund or investment platform manages on behalf of clients."
  },
  {
    term: "Cap Table",
    definition: "Short for capitalization table, a spreadsheet showing the equity ownership capitalization for a company, including all securities, ownership percentages, and valuations."
  },
  {
    term: "Convertible Note",
    definition: "A type of short-term debt that converts into equity, typically used in early-stage startup financing. The debt automatically converts to equity during a future financing round."
  },
  {
    term: "Due Diligence",
    definition: "The comprehensive investigation and analysis of a potential investment, including financial records, legal documents, market position, and team capabilities."
  },
  {
    term: "Equity",
    definition: "Ownership interest in a company, typically in the form of stock or shares. Equity investors own a portion of the company."
  },
  {
    term: "Exit",
    definition: "The method by which an investor realizes gains from their investment, typically through acquisition (M&A) or initial public offering (IPO)."
  },
  {
    term: "IPO (Initial Public Offering)",
    definition: "The process by which a private company offers shares to the public for the first time, becoming a publicly traded company."
  },
  {
    term: "Lead Investor",
    definition: "The primary investor in a funding round who typically invests the most capital and often negotiates deal terms on behalf of other investors."
  },
  {
    term: "Liquidity Event",
    definition: "An event that allows investors to convert their ownership stake into cash, such as an acquisition, IPO, or secondary sale."
  },
  {
    term: "Post-Money Valuation",
    definition: "The valuation of a company immediately after a financing round, including the new investment capital."
  },
  {
    term: "Pre-Money Valuation",
    definition: "The valuation of a company before a new financing round, not including the new investment capital."
  },
  {
    term: "Portfolio",
    definition: "The collection of investments held by an individual investor or managed fund."
  },
  {
    term: "Preferred Stock",
    definition: "A class of stock that has preferential rights over common stock, typically including liquidation preferences and anti-dilution protection."
  },
  {
    term: "Seed Round",
    definition: "The initial capital raised by a startup to prove its concept and reach early milestones. Usually the first official equity funding stage."
  },
  {
    term: "Series A, B, C",
    definition: "Subsequent rounds of financing after the seed round. Series A typically focuses on scaling, Series B on growth, and Series C on expansion."
  },
  {
    term: "Term Sheet",
    definition: "A non-binding agreement outlining the key terms and conditions of an investment, serving as a template for more detailed legal documents."
  },
  {
    term: "Unicorn",
    definition: "A privately held startup company valued at over $1 billion."
  },
  {
    term: "Valuation",
    definition: "The process of determining the current worth of a company, considering various factors including revenue, growth, market size, and comparable companies."
  },
  {
    term: "Venture Capital (VC)",
    definition: "A form of private equity financing provided by firms or funds to startups and small businesses with high growth potential."
  },
  {
    term: "Vesting",
    definition: "The process by which an employee or founder earns their equity over time, typically over 3-4 years with a 1-year cliff."
  }
];

export const glossaryCategories = [
  {
    name: "Investment Basics",
    terms: ["Accredited Investor", "Angel Investor", "Equity", "Portfolio", "Venture Capital (VC)"]
  },
  {
    name: "Valuation & Financing",
    terms: ["Pre-Money Valuation", "Post-Money Valuation", "Seed Round", "Series A, B, C", "Convertible Note"]
  },
  {
    name: "Returns & Exits",
    terms: ["Exit", "IPO (Initial Public Offering)", "Liquidity Event", "Unicorn"]
  },
  {
    name: "Legal & Structure",
    terms: ["Cap Table", "Preferred Stock", "Term Sheet", "Vesting", "Due Diligence"]
  }
];

export default glossary;
